/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Reflex API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AgentGroupMembersRequest
} from './model/agentGroupMembersRequest.js';

import type {
  AgentGroupResponse
} from './model/agentGroupResponse.js';

import type {
  CreateAgentGroupRequest
} from './model/createAgentGroupRequest.js';

import type {
  ListAgentGroupsResponse
} from './model/listAgentGroupsResponse.js';

import type {
  UpdateAgentGroupRequest
} from './model/updateAgentGroupRequest.js';

import { apiFetch } from '../react-mutator.js';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List the current user's agent groups in the active organization.
 */
export const listAgentGroups = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListAgentGroupsResponse>(
      {url: `/agent-groups`, method: 'GET', signal
    },
      options);
    }




export const getListAgentGroupsQueryKey = () => {
    return [
    `/agent-groups`
    ] as const;
    }


export const getListAgentGroupsQueryOptions = <TData = Awaited<ReturnType<typeof listAgentGroups>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAgentGroups>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAgentGroupsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAgentGroups>>> = ({ signal }) => listAgentGroups(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAgentGroups>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAgentGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof listAgentGroups>>>
export type ListAgentGroupsQueryError = unknown


/**
 * @summary List the current user's agent groups in the active organization.
 */

export function useListAgentGroups<TData = Awaited<ReturnType<typeof listAgentGroups>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAgentGroups>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAgentGroupsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Create an agent group, optionally with its first members.
 */
export const createAgentGroup = (
    createAgentGroupRequest: CreateAgentGroupRequest,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<AgentGroupResponse>(
      {url: `/agent-groups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAgentGroupRequest, signal
    },
      options);
    }




export const getCreateAgentGroupMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAgentGroup>>, TError,{data: CreateAgentGroupRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAgentGroup>>, TError,{data: CreateAgentGroupRequest}, TContext> => {

const mutationKey = ['createAgentGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAgentGroup>>, {data: CreateAgentGroupRequest}> = (props) => {
          const {data} = props ?? {};

          return  createAgentGroup(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAgentGroupMutationResult = NonNullable<Awaited<ReturnType<typeof createAgentGroup>>>
    export type CreateAgentGroupMutationBody = CreateAgentGroupRequest
    export type CreateAgentGroupMutationError = unknown

    /**
 * @summary Create an agent group, optionally with its first members.
 */
export const useCreateAgentGroup = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAgentGroup>>, TError,{data: CreateAgentGroupRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAgentGroup>>,
        TError,
        {data: CreateAgentGroupRequest},
        TContext
      > => {
      return useMutation(getCreateAgentGroupMutationOptions(options));
    }
    /**
 * @summary Rename an agent group.
 */
export const updateAgentGroup = (
    groupId: string,
    updateAgentGroupRequest: UpdateAgentGroupRequest,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<AgentGroupResponse>(
      {url: `/agent-groups/${encodeURIComponent(String(groupId))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateAgentGroupRequest, signal
    },
      options);
    }




export const getUpdateAgentGroupMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAgentGroup>>, TError,{groupId: string;data: UpdateAgentGroupRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAgentGroup>>, TError,{groupId: string;data: UpdateAgentGroupRequest}, TContext> => {

const mutationKey = ['updateAgentGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAgentGroup>>, {groupId: string;data: UpdateAgentGroupRequest}> = (props) => {
          const {groupId,data} = props ?? {};

          return  updateAgentGroup(groupId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAgentGroupMutationResult = NonNullable<Awaited<ReturnType<typeof updateAgentGroup>>>
    export type UpdateAgentGroupMutationBody = UpdateAgentGroupRequest
    export type UpdateAgentGroupMutationError = unknown

    /**
 * @summary Rename an agent group.
 */
export const useUpdateAgentGroup = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAgentGroup>>, TError,{groupId: string;data: UpdateAgentGroupRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAgentGroup>>,
        TError,
        {groupId: string;data: UpdateAgentGroupRequest},
        TContext
      > => {
      return useMutation(getUpdateAgentGroupMutationOptions(options));
    }
    /**
 * @summary Delete an agent group and every membership in it.
 */
export const deleteAgentGroup = (
    groupId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/agent-groups/${encodeURIComponent(String(groupId))}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteAgentGroupMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAgentGroup>>, TError,{groupId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAgentGroup>>, TError,{groupId: string}, TContext> => {

const mutationKey = ['deleteAgentGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAgentGroup>>, {groupId: string}> = (props) => {
          const {groupId} = props ?? {};

          return  deleteAgentGroup(groupId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAgentGroupMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAgentGroup>>>

    export type DeleteAgentGroupMutationError = unknown

    /**
 * @summary Delete an agent group and every membership in it.
 */
export const useDeleteAgentGroup = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAgentGroup>>, TError,{groupId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAgentGroup>>,
        TError,
        {groupId: string},
        TContext
      > => {
      return useMutation(getDeleteAgentGroupMutationOptions(options));
    }
    /**
 * @summary File agents into a group, moving them out of any other group.
 */
export const addAgentGroupMembers = (
    groupId: string,
    agentGroupMembersRequest: AgentGroupMembersRequest,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<AgentGroupResponse>(
      {url: `/agent-groups/${encodeURIComponent(String(groupId))}/members`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: agentGroupMembersRequest, signal
    },
      options);
    }




export const getAddAgentGroupMembersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addAgentGroupMembers>>, TError,{groupId: string;data: AgentGroupMembersRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addAgentGroupMembers>>, TError,{groupId: string;data: AgentGroupMembersRequest}, TContext> => {

const mutationKey = ['addAgentGroupMembers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addAgentGroupMembers>>, {groupId: string;data: AgentGroupMembersRequest}> = (props) => {
          const {groupId,data} = props ?? {};

          return  addAgentGroupMembers(groupId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddAgentGroupMembersMutationResult = NonNullable<Awaited<ReturnType<typeof addAgentGroupMembers>>>
    export type AddAgentGroupMembersMutationBody = AgentGroupMembersRequest
    export type AddAgentGroupMembersMutationError = unknown

    /**
 * @summary File agents into a group, moving them out of any other group.
 */
export const useAddAgentGroupMembers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addAgentGroupMembers>>, TError,{groupId: string;data: AgentGroupMembersRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addAgentGroupMembers>>,
        TError,
        {groupId: string;data: AgentGroupMembersRequest},
        TContext
      > => {
      return useMutation(getAddAgentGroupMembersMutationOptions(options));
    }
    /**
 * @summary Remove agents from a group.
 */
export const removeAgentGroupMembers = (
    groupId: string,
    agentGroupMembersRequest: AgentGroupMembersRequest,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<AgentGroupResponse>(
      {url: `/agent-groups/${encodeURIComponent(String(groupId))}/members`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: agentGroupMembersRequest, signal
    },
      options);
    }




export const getRemoveAgentGroupMembersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAgentGroupMembers>>, TError,{groupId: string;data: AgentGroupMembersRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeAgentGroupMembers>>, TError,{groupId: string;data: AgentGroupMembersRequest}, TContext> => {

const mutationKey = ['removeAgentGroupMembers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeAgentGroupMembers>>, {groupId: string;data: AgentGroupMembersRequest}> = (props) => {
          const {groupId,data} = props ?? {};

          return  removeAgentGroupMembers(groupId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveAgentGroupMembersMutationResult = NonNullable<Awaited<ReturnType<typeof removeAgentGroupMembers>>>
    export type RemoveAgentGroupMembersMutationBody = AgentGroupMembersRequest
    export type RemoveAgentGroupMembersMutationError = unknown

    /**
 * @summary Remove agents from a group.
 */
export const useRemoveAgentGroupMembers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAgentGroupMembers>>, TError,{groupId: string;data: AgentGroupMembersRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeAgentGroupMembers>>,
        TError,
        {groupId: string;data: AgentGroupMembersRequest},
        TContext
      > => {
      return useMutation(getRemoveAgentGroupMembersMutationOptions(options));
    }
